import { Component, OnInit, OnDestroy } from '@angular/core';
import { EnvironmentService } from '@omnipas/services/environment.service';
import { ListService }        from '@omnilib/services/list.service';
import { LoadingService }     from '@omnipas/services/loading.service';
import { MessageService }     from '@omnipas/services/message.service';
import { PageHeaderService }  from '@omnipas/services/pageheader.service';
import { PhotoService }       from '@omnipas/services/photo.service';
import { RouterService }      from '@omnipas/services/router.service';

@Component({
  selector: 'omnipas-photoresult',
  templateUrl: './photoresult.component.html'
})
export class PhotoResultComponent implements OnInit, OnDestroy {

  initialized:      boolean = false;
  deliveryaddress:  boolean = false;
  deliveryaddress2: boolean = false;

  constructor ( public environment: EnvironmentService
              , public list:        ListService
              , public loading:     LoadingService
              , public message:     MessageService
              , public pageheader:  PageHeaderService
              , public photo:       PhotoService
              , public router:      RouterService
              ) {
  }

  async ngOnInit() {
    this.router.toggleshowwait( true );

    this.initialized = false;

    if ( this.list.emptyList( this.router.persondata ) ) {
      this.router.logout();
    } else {
      this.pageheader.setPageHeader( 'pagetitle.photoresult' );
    }

    this.deliveryaddress  = this.message.success
                         && this.environment.getEnvValue('deliveryaddress')
                         && this.photo.firstphoto
                         && ( this.list.getValue( this.router.persondata, 'cardholderProfile', true ).toLowerCase() == 'student' );

    this.deliveryaddress2  = this.message.success
                         && this.environment.getEnvValue('deliveryaddress2')
                         && this.photo.firstphoto
                         && ( this.list.getValue( this.router.persondata, 'cardholderProfile', true ).toLowerCase() == 'student' );

    this.initialized     = true;
    this.router.toggleshowwait( false );
  }

  logout() {
    this.router.logout();
  }

  back() {
    this.router.goTo('photo');
  }

  continue() {
    if(this.deliveryaddress) {
      this.router.goTo('deliveryaddress');
    } else if (this.deliveryaddress2) {
      this.router.goTo('deliveryaddress2')
    }
  }

  ngOnDestroy() {
    return;
  }

}
